// extracted by mini-css-extract-plugin
module.exports = {"outerSearch":"SearchBar_outerSearch__18GlV","searchIcon":"SearchBar_searchIcon__2YQhg","search":"SearchBar_search__7XedB"};